import React, {useCallback, useEffect} from 'react';
import { useDispatch} from 'react-redux';
import { modalActions } from '../../redux/root-action';
import ReactModalContent from '../Shared/Modal/ReactModalContent';
import ReactModalFooter from '../Shared/Modal/ReactModalFooter';
import { modals } from '../../utils/constants';
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";

export const SignUpModal = ({modalName,handleCloseModal,dispatchOverlayLoad}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const overlay = "Unauthenticated Number Change Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const showSignUpAgreementModal = useCallback(() => {
        handleCloseModal()
        dispatch(modalActions.showModal(modals.SIGN_UP_AGREEMENT_MODAL));
    },[dispatch]);

    const getFooter = () => {
        return <ReactModalFooter
            tertiaryButtonText={"Skip"}
            primaryButtonText={"Sign Up"}
            handleOnClick={showSignUpAgreementModal}
            handleCancelClick={handleCloseModal}
            primaryButtonId = {ANALYTICS_IDS.SignUpModalSkipBtn}
            tertiaryButtonId={ANALYTICS_IDS.SignUpModalSignUpBtn}
        />
    };

    return (
        <React.Fragment>
            <BeaconModal id={modalName}
                         footer={getFooter()}>

                <ReactModalContent>
                    <ReactModalHeader modalTitle="Sign up for text alerts"/>
                    Because your mobile number has changed, you will no longer receive text alerts. You can sign up for text
                    alerts with your updated mobile number.

                </ReactModalContent>
            </BeaconModal>
        </React.Fragment>
    )
}

